import { BaseError } from "@/domains/errors/kinds/BaseError";
import { AppErrorCode } from "@/domains/errors/constants";
import { ErrorOptions } from "@/domains/errors/types";
import { GatedFeature } from "@/store/feature-gates/types";
import { PaywallContext } from "@/domains/metrics/tracked-event";

interface FeatureGateErrorOptions extends ErrorOptions {
  feature: GatedFeature;
  used: number;
  limit: number | typeof Infinity;
  paywallContext: PaywallContext;
}

export class FeatureGateError extends BaseError {
  public readonly feature: GatedFeature;
  public readonly used: number;
  public readonly limit: number | typeof Infinity;
  public readonly paywallContext: PaywallContext;

  constructor({ feature, used, limit, paywallContext, ...rest }: FeatureGateErrorOptions) {
    super({
      code: rest.code ?? AppErrorCode.RUNTIME,
      statusCode: rest.statusCode ?? 403,
      ...rest,
    });

    this.feature = feature;
    this.used = used;
    this.limit = limit;
    this.paywallContext = paywallContext;
  }
}
